<template>
  <div>
    <el-table
      :data="Machindata"
      style="width: 60%">
      <el-table-column
        prop="machineName"
        label="机器名称"
        width="180">
      </el-table-column>
      <el-table-column prop="isShow" width="400"  label="开关">
        <template slot-scope="scoped">
            <el-switch
            v-model="scoped.row.isShow"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="启用" 
            inactive-text="关闭"
            :active-value="1"
            :inactive-value="0"
            :width="60"
            @change="updateStatus(scoped.row)"
        >
        </el-switch>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {machineStatus,machineStatusUpdate} from "@/assets/api/feedingStyle"
export default {
    data(){
        return{
            Machindata:[]
        }
    },
    mounted(){
        
        //获取机器动画开关数据
        this.getMachineStatus();
    },
    methods:{
       async updateStatus(row){
         let res = await machineStatusUpdate(row)
          if (res.code == "200"){
               this.$message.success("修改成功!");
               this.getMachineStatus();
              
          }else{
              this.$message.error("修改错误!");
          }
        },
        //获取机器动画开关数据
        async getMachineStatus(){
            let {data} = await machineStatus();
            this.Machindata = data;
            window.animaType = this.Machindata;
            //console.log(this.Machindata);
        }
    }
}
</script>

<style>

</style>